import React, { createContext, useReducer } from "react"

import appReducer from "./../reducers/appReducer.js"

export const AppContext = createContext()

export const AppProvider = (props) => {
    const appInitialState = {
        color: {
            primary: '#141414',
            secondary: '#C9C7C6',
            cold: '#DEDEDC',
            active: '#2F3B49',
            light: '#FAFAFA',
            dark: '#1E1E1E',
        },
    }

    const [state, dispatch] = useReducer(appReducer, appInitialState)

    return (
        <AppContext.Provider value={{ state: state, dispatch: dispatch }}>
            {props.children}
        </AppContext.Provider>
    )
}